var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWordWizardGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "48px",
    viewBox: "0 0 45 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "rewards/word-wizard-gold") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.00010546875 0 45 0 45 47.9999652 0.00010546875 47.9999652"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.00010546875 0 45 0 45 44.5217043 0.00010546875 44.5217043"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0.00010546875 0 45 0 45 44.5217043 0.00010546875 44.5217043"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Product",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-Rewards-1440",
    transform: "translate(-1006.000000, -489.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rewards/word-wizard-gold",
    transform: "translate(1006.000000, 489.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5001055,47.9999652 L22.5001055,47.9999652 C10.0734258,47.9999652 0.00010546875,38.0333565 0.00010546875,25.7390957 L0.00010546875,4.17387826 C0.00010546875,1.86883478 1.88905078,-3.47826087e-05 4.21885547,-3.47826087e-05 L40.7813555,-3.47826087e-05 C43.1111602,-3.47826087e-05 45.0001055,1.86883478 45.0001055,4.17387826 L45.0001055,25.7390957 C45.0001055,38.0333565 34.9264336,47.9999652 22.5001055,47.9999652",
    id: "Fill-1",
    fill: "#AD8D07",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5001055,44.5217043 L22.5001055,44.5217043 C10.0734258,44.5217043 0.00010546875,34.5550957 0.00010546875,22.2608348 L0.00010546875,4.17387826 C0.00010546875,1.86883478 1.88905078,-3.47826087e-05 4.21885547,-3.47826087e-05 L40.7813555,-3.47826087e-05 C43.1111602,-3.47826087e-05 45.0001055,1.86883478 45.0001055,4.17387826 L45.0001055,22.2608348 C45.0001055,34.5550957 34.9264336,44.5217043 22.5001055,44.5217043",
    id: "Fill-4",
    fill: "#FFDC4A",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7813555,-3.47826087e-05 L4.21885547,-3.47826087e-05 C1.88905078,-3.47826087e-05 0.00010546875,1.86883478 0.00010546875,4.17387826 L0.00010546875,22.2608348 C0.00010546875,34.5550957 10.0734258,44.5217043 22.5001055,44.5217043 L22.5001055,44.5217043 C34.9264336,44.5217043 45.0001055,34.5550957 45.0001055,22.2608348 L45.0001055,4.17387826 C45.0001055,1.86883478 43.1111602,-3.47826087e-05 40.7813555,-3.47826087e-05 M40.7813555,4.17387826 L40.7813555,22.2608348 C40.7813555,32.2340522 32.580457,40.3477913 22.5001055,40.3477913 C12.4197539,40.3477913 4.21885547,32.2340522 4.21885547,22.2608348 L4.21885547,4.17387826 L40.7813555,4.17387826",
    id: "Fill-7",
    fill: "#D3AB05",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.6325586,10.4628522 C32.4363867,10.2072 32.114707,10.0757217 31.7902148,10.0757217 L25.1745117,10.0757217 L25.1407617,10.0757217 C21.9120117,10.0757217 19.0070508,12.0169391 17.8011914,14.9800696 L12.9425977,26.9181565 L31.9698633,26.9181565 L27.3004102,15.3445913 C27.0824414,14.805113 27.3331055,14.1915478 27.8685352,13.9529391 L32.246543,12.0037217 C32.8318945,11.7432 33.0477539,11.0030261 32.6325586,10.4628522",
    id: "Fill-10",
    fill: "#AD8D07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3708242,29.5763826 L10.629457,29.5763826 C9.78148828,29.5763826 9.09383203,28.8963826 9.09383203,28.0574261 C9.09383203,27.2181217 9.78148828,26.5381217 10.629457,26.5381217 L34.3708242,26.5381217 C35.218793,26.5381217 35.9060977,27.2181217 35.9060977,28.0574261 C35.9060977,28.8963826 35.218793,29.5763826 34.3708242,29.5763826",
    id: "Fill-12",
    fill: "#8C7100"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    fill: "#D5F6FF",
    points: "22.4999297 18.0790957 19.6993828 20.8498783 22.4999297 23.6206609 25.3004766 20.8498783"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    fill: "#A4DDEA",
    points: "22.4999297 18.0790957 19.6993828 20.8498783 22.4999297 23.6206609"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordWizardGold);
export default __webpack_public_path__ + "static/media/word-wizard-gold.b5591215d345f05e2914e443804a667e.svg";
export { ForwardRef as ReactComponent };